import * as React from 'react';
import * as ReactDom from 'react-dom';
import * as ReactIntl from 'react-intl';
import * as jsx from 'react/jsx-runtime';

window.Applant.fragments['react-base-fragment'] = {
    React,
    ReactDom,
    ReactIntl,
    jsx,
};

window.dispatchEvent(new Event('applant:ready'));
